/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import { CheckSumsHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';
import { PageQueryParams } from '../../../api/apiCommon.typings';

export enum CashBoxCheckSumsTabActionType {
    EXIT_CASHBOX_CHECKSUMS_TAB = 'CashBoxCheckSumsTab/ exit tab',
    FETCH_CHECKSUMS_HISTORY = 'CashBoxCheckSumsTab/ fetch checksums history start',
    FETCH_CHECKSUMS_HISTORY_SUCCESS = 'CashBoxCheckSumsTab/ fetch checksums history success',
    FETCH_CHECKSUMS_HISTORY_ERROR = 'CashBoxCheckSumsTab/ fetch checksums history error',
}

export const exitCashBoxCheckSumsTabAction = () =>
    createAction(CashBoxCheckSumsTabActionType.EXIT_CASHBOX_CHECKSUMS_TAB);

export const fetchCheckSumsHistoryAction = (params: PageQueryParams) =>
    createAction(CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY, params);

export const fetchCheckSumsHistorySuccessAction = (payload: CheckSumsHistoryDto) =>
    createAction(CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY_SUCCESS, payload);

export const fetchCheckSumsHistoryErrorAction = (notification: Notification) =>
    createAction(CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY_ERROR, { notification });

export type CashBoxCheckSumsTabAction =
    | ReturnType<typeof exitCashBoxCheckSumsTabAction>
    | ReturnType<typeof fetchCheckSumsHistoryAction>
    | ReturnType<typeof fetchCheckSumsHistorySuccessAction>
    | ReturnType<typeof fetchCheckSumsHistoryErrorAction>;
